export enum CashflowType {
  Coupon = 'coupon',
  Principal = 'principal',
  Dividend = 'dividend',
  Call = 'call',
}

export interface Cashflow {
  date: string
  amount: number
  type: CashflowType
}

export interface Statistics {
  timestamp: string
  total_market_value: number
  treasury_market_value: number
  corporate_market_value: number
  agency_market_value: number
  government_market_value: number
  municipal_market_value: number
  cd_market_value: number
  average_ytw: number
  average_purchase_ytw?: number
  average_book_ytw?: number
  average_market_post_tax_ytw?: number
  average_purchase_tey?: number
  average_mid_eval_taxable_equivalent_yield?: number
  average_maturity: number
  average_duration: number
  average_sp_rating: string
  average_moodys_rating: string
  average_lowest_rating?: string
  average_coupon: number
  average_z_spread?: number
  monthly_cashflows: Cashflow[]
  yearly_cashflows: Cashflow[]
  municipal_state_distribution: Record<string, number>
  sp_rating_distribution: Record<string, number>
  maturity_distribution: Record<string, number>
  sector_distribution: Record<string, number>
  issuer_distribution: Record<string, number>
  coupon_distribution: Record<string, number>
  moodys_rating_distribution: Record<string, number>
  municipal_type_distribution: Record<string, number>
  num_holdings?: number
}
